// extracted by mini-css-extract-plugin
module.exports = {"header":"FilterDrawerPermits_header__1pXvR"};